import { useEffect } from 'react'
import { trackExperimentViewed } from '@mc/track-event'

type Props = {
  name: string
  children: React.ReactNode
}

export const ExperimentTracker = ({ children, name }: Props) => {
  useEffect(() => trackExperimentViewed(name), [name])

  return children
}

export default ExperimentTracker
